
import Button from '../button/index';

export default {
  name: 'collapsemutiselect2',
  components: {
    Button,
  },
  props: {
    title:{
      type: String,
      required: false,
      default:'Devices or Group',
    },
    scaleType:{
      type: String,
      required: false,
      default:'Devices',
    },
    data : {
      type: Array,
      required: false,
      default:[
        {
          name: 'SN-0123456789',
          val: 'SN-0123456789',
        },
        {
          name: '111',
          val: '111',
          eee: 'eee',
          ooo: 'ooo',
        },
        {
          name: '222',
          val: '222',
          eee: 'eee',
          ooo: 'ooo',
        },
      ],
    },
  },
  data () {
    return {
      dataArr:this.data,
      fulfill:[],
      heightAuto:false,
      showDetail: null,
      left: null,
      top: null,
      isMOdalEmpty: undefined,
      orgX: null,
      orgY:null,
    }
  },
  mounted(){
    let target = this.$refs.collapsemutiselect2;  //計算原本此組件的絕對位置
    this.orgX = target.getBoundingClientRect().x;
    this.orgY = target.getBoundingClientRect().y;
  },
  computed: {
    itemClass(){
      // 使用更可靠的定位方式
      const left = this.left - this.orgX;
      const top = this.top + 50 - this.orgY;
      
      return {
        left: `${Math.max(0, left)}px`, // 確保不會跑到負數位置
        top: `${Math.max(0, top)}px`,   // 確保不會跑到負數位置
        position: 'absolute',
        zIndex: 1000, // 提高 z-index 確保在最上層
      };
    },
    division(){
      let division;

      if(this.dataArr.length>5){
        division = Math.ceil((this.dataArr.length-5) / 6);
      }else{
        division = Math.ceil(this.dataArr.length / 5);
      }
      // console.log('division',division)
      if(division > 1){
        return true
      }else{
        return false 
      }
    },
    selectTitle(){
      return 'Select '+ this.title
    },
    defaultTitle(){
      return  this.title + ' List'
    },
    fulfillArr(){ //塞空陣列
      let arr = []
      if(!this.dataArr.length){
        let fulfillNum = 11;
        for (let index = 0; index < fulfillNum; index++) {
          arr.push(index)
        }
      }else{
        let leftNum;
        let fulfillNum;
        if(this.dataArr.length>5){
          leftNum = (this.dataArr.length-5) % 6;
          fulfillNum = 6 - leftNum ;
          // console.log('0',fulfillNum, leftNum)
        }else{
          leftNum = this.dataArr.length % 6;
          fulfillNum = 11-leftNum
        }
        // console.log('?',fulfillNum)

        if(leftNum ){
          for (let index = 0; index < fulfillNum; index++) {
            arr.push(index)
          }
        }
      }
      return arr
    }
  },
  methods: {
    clickData(e,index , item){
      // console.log('r',index,e)
      this.left = e.target.getBoundingClientRect().left;
      this.top = e.target.getBoundingClientRect().top;
      // console.log(left,'r',top,index)
      
      this.isMOdalEmpty = Object.keys(item)
                .filter( key => key && key != 'name' && key != 'val' ).length ? true :false
      this.showDetail = index;
    },
    // const clickPopUpEffect = (col ,i ,row) => {
    //   if (col.clickPopUp) {
    //     state.clickIndex = i;
    //     state.clickContent = row[col.clickPopUp] ;
    //   }
    // }
    handleFocusOut() {
      this.showDetail = null;
      // state.clickContent = []
      // state.clickIndex = null;
    },

    openModal(){
      this.$emit('showModal', true)
      // this.isShowModal = true;
    },
    openBox(){
      this.heightAuto = !this.heightAuto;
    }
  },
  watch:{
    // heightAuto:{
    //   handler: function(n){
    //     this.dataArr = n
    //   },
    // },
    data:{
      handler: function(n){
        this.dataArr = n
      },
      deep: true,
    }
  }
}


